import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Alert } from '@material-ui/lab';
import { Snackbar} from '@material-ui/core';
import { closeSnackbarNotification } from 'redux/actions/ui';


const PopUpNotifications = () => {
  const dispatch = useDispatch();
  const {notificationsStack} = useSelector((state) => state.ui);

  const handleClose = (reason, key) => {
    if (reason === 'clickaway') {
      return;
    }

    dispatch(closeSnackbarNotification(key));
  };
  return (
    <>
      {notificationsStack.map((notification, index) => {
        const {isOpen, message, type, key} = notification;
        return (
          <Snackbar
            key={key}
            anchorOrigin={{vertical: 'top', horizontal: 'right'}}
            open={isOpen}
            onClose={(event, reason) => handleClose(reason, key)}
            autoHideDuration={3000}
            style={{top: `${(index * 3 * 24) + 24}px`}}
          >
            <Alert
              elevation={6}
              variant="filled"
              color={type}
            >
              {message}
            </Alert>
          </Snackbar>
        );
      })}
    </>
  );
};

export default PopUpNotifications;
